import React from 'react';
import { Container, Grid } from '@material-ui/core';
import { useLocation } from 'react-router-dom';
import HOCLoader from 'Components/Loader/HOCLoader';

const CustomContainer = HOCLoader(Container);

export const URLRedirect = () => {
    const location = useLocation();
    const RedirectURL = location.state.RedirectURL;

    return (
        <CustomContainer>
            <Grid container spacing={1}>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                    <iframe
                        title="SDK Transaction"
                        src={RedirectURL}
                        width="100%"
                        style={{
                            height: '90vh',
                            border: 'none',
                            background: '#fff'
                        }}
                    ></iframe>
                </Grid>
            </Grid>
        </CustomContainer>
    );
};
